import { atom } from 'recoil';

export const refreshCustomerBenefitsAtom = atom({
    key: 'refreshCustomerBenefitsAtom',
    default: {}
});
